<template>
  <div class="information-poi" role="article">
    <div class="description-poi" role="presentation">
      <h3 v-if='poi' class='name-of-poi main-color'>{{ $tr(poi.name) }}<span style="color:grey;"> &middot; {{$store.state.college.name}}</span></h3>
      <audio-player v-for="audio in audioList" :key="audio.id" :audio="audio" />
      <p class='description' v-html="$tr(poi.information)"></p>
      <router-link :to="{name: 'PoiDirections'}" class="point" tag="a" v-if="poi.addressFirst">
        <i class="material-icons" aria-hidden="true">directions</i>
        <p class="address">{{ poi.addressFirst }}<span v-if="poi.addressSecond">, {{ poi.addressSecond }}</span></p>
      </router-link>
      <p class="label-wrapper" v-if="!poi.isPubliclyAccessible">
        <span class="label" v-if="poi.label && $tr(poi.label)">{{ $tr(poi.label) }}</span>
        <span class="label" v-else>{{ $t('message.restrictedPublicAccess') }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AudioPlayer from '@/components/AudioPlayer'

export default {
  name: 'PoiInformation',
  components: {
    AudioPlayer
  },
  created () {
    this.getPOIById(this.$route.params.id)
  },
  methods: {
    ...mapActions('poi', ['getPOIById'])
  },
  computed: {
    audioList: function () {
      return this.poi.content.filter(item => item.type === 'audio' && item.job.outputs.length > 0)
    },
    ...mapState('poi', {
      poi: state => state.currentPoi
    })
  }
}
</script>
